import { Box, Checkbox, Tooltip, Typography } from "@mui/material";
import FluidDatePicker from "../../../../common/components/FluidDatePicker";
import { noop } from "../../../../common/utils/operations";
import { truncate } from "../../../../common/utils/truncate";
import { Spacer } from "../../../../common/components/Spacer";
import { borderNeutralSecondary } from "../../../../core/theme";
import { If } from "../../../../common/components/If";

export interface HorizonUnitProps {
	name: string;
	attributeName: string;
	oldValue: string;
	newValue: string;
	isChecked: boolean;
	cardWidth?: number;
	oldValueErrorMessage?: string;
	newValueErrorMessage?: string;
	readonly?: boolean;
	onChangeOldValue?: (event: any) => void;
	onChangeNewValue?: (event: any) => void;
	onChangeIsChecked?: (event: any) => void;
}

const HorizonUnit = ({
	name,
	attributeName,
	oldValue,
	newValue,
	isChecked,
	cardWidth = 380,
	oldValueErrorMessage = "",
	newValueErrorMessage = "",
	readonly = false,
	onChangeOldValue = noop,
	onChangeNewValue = noop,
	onChangeIsChecked = noop,
}: HorizonUnitProps) => {
	const style = {
		container: {
			backgroundColor: "#052B5014",
			padding: "16px",
			width: `${cardWidth}px`,
			border: `1px solid ${borderNeutralSecondary}`,
		},
		dateContainer: {
			display: "flex",
			flexDirection: "row",
			gap: "24px",
		},
		nameContainer: {
			display: "flex",
			flexDirection: "row",
			gap: "8px",
			alignItems: "center",
			justifyContent: "space-between",
		},
	};

	return (
		<Box sx={style.container}>
			<Box sx={style.nameContainer}>
				<Box display="flex" alignItems="center">
					<If condition={!readonly}>
					<Checkbox
						checked={isChecked}
						onChange={onChangeIsChecked}
					/>
					</If>
					<Tooltip arrow title={name}>
						<Typography component="h3">
							{truncate(name, 20)}
						</Typography>
					</Tooltip>
				</Box>

				<Typography component="p">{attributeName}</Typography>
			</Box>
			<Spacer gap={8} />
			<Box sx={style.dateContainer}>
				<FluidDatePicker
					disabled
					onChange={onChangeOldValue}
					name={"old_value"}
					label={"Old Value"}
					value={oldValue}
					errorMessage={oldValueErrorMessage}
				/>
				<FluidDatePicker
					onChange={onChangeNewValue}
					name={"new_value"}
					label={"New Value"}
					value={newValue}
					isReadOnly={readonly}
					errorMessage={newValueErrorMessage}
				/>
			</Box>
		</Box>
	);
};

export default HorizonUnit;
